import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { CommentListConnector } from "../../comment/list/CommentListConnector";
import { PostDetailsHeaderConnector } from "./PostDetailsHeaderConnector";


export class PostDetailsConnector extends React.PureComponent<RouteComponentProps<{ postId: string }>> {

	render() {
		const { postId } = this.props.match.params;
		return (
			<div>
				<PostDetailsHeaderConnector postId={postId} />
				<CommentListConnector postId={postId} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/modules/post/details/PostDetailsConnector.tsx